import { createTypes } from 'redux-recompose';

export const actions = createTypes(['APPLY_SELECTED_DISMISSION_REPORT'], '@@PML');

const actionCreators = {
    APPLY_SELECTED_DISMISSION_REPORT: (response) => ({ type: actions.APPLY_SELECTED_DISMISSION_REPORT, notification: response }),
};

export default actionCreators;